"use client";
import e from "react";
import { loadStoryblokBridge as r } from "./storyblok-js.mjs";
const t = async (o) => {
  await r(), new window.StoryblokBridge(o).on(["published", "change"], () => {
    window.location.reload();
  });
}, i = ({ options: o }) => (t(o), /* @__PURE__ */ e.createElement(e.Fragment, null));
export {
  i as default
};
